<router-outlet></router-outlet> <!-- Punto di ingresso per i layout e le pagine -->
<app-toast-container></app-toast-container> <!-- Container globale per le notifiche toast -->
<app-cookie-banner></app-cookie-banner> <!-- Informativa cookie globale, in basso a destra -->
